import { apiRequest } from "@portal/lib/ky/utils";
import { InvoiceListFilters } from "@portal/store/Filters/Invoices/type";
import {
  Invoice,
  InvoiceDetails,
  InvoiceLineItem,
  InvoiceStatus,
  LineItemParams,
} from "@portal/types/entities/invoice";
import { PageList } from "@portal/types/page-list";
import { RequestConfig } from "../types/common";

export interface InvoiceSearchParams {
  searchText: string;
  status?: InvoiceStatus[];
}
export async function getInvoiceList(
  params: RequestConfig<InvoiceListFilters>
) {
  const { page, size, filters } = params;
  const data = await apiRequest<
    RequestConfig<InvoiceListFilters>["filters"],
    PageList<Invoice, undefined>
  >({
    method: "POST",
    url: "v1/invoices/report",
    data: filters,
    searchParams: { page, size },
  });
  return await data.json();
}

export async function invoiceSearch(params: InvoiceSearchParams) {
  const data = await apiRequest<
    RequestConfig<
      Pick<InvoiceListFilters, "search_text" | "statuses">
    >["filters"],
    PageList<Invoice, undefined>
  >({
    method: "POST",
    url: "v1/invoices/report",
    data: { search_text: params.searchText, statuses: params.status },
    searchParams: { size: 1000 },
  });
  return await data.json();
}

export async function getInvoices() {
  const data = await apiRequest<unknown, Invoice[]>({
    method: "GET",
    url: "v1/invoices",
  });
  return await data.json();
}

export async function getLineItem(params: string[]) {
  const data = await apiRequest<
    LineItemParams,
    PageList<InvoiceLineItem, undefined>
  >({
    method: "POST",
    url: "v1/invoices/line-items",
    data: {
      invoice_ids: params,
    },
  });
  return await data.json();
}

export async function getInvoicesDetails(params?: string) {
  const data = await apiRequest<unknown, InvoiceDetails>({
    method: "GET",
    url: `v1/invoices/${params?.toString()}`,
  });
  return await data.json();
}
